import { forwardRef } from 'react';
import { useMapLayersState } from 'state/useMapLayersState';
import LegendDrawerContent from '../../../../../components/Map/legends/LegendDrawerContent';
import { LayerGroups } from './LayerGroups';

export const DrawerContent = forwardRef<HTMLDivElement>(
  (_, ref): JSX.Element => {
    const { drawerContent } = useMapLayersState();

    if (drawerContent === 'legends') {
      return <LegendDrawerContent ref={ref} />;
    }
    return <LayerGroups ref={ref} />;
  },
);

DrawerContent.displayName = 'DrawerContent';
